export function hasOwnProperty<T>(obj: T, prop: string): boolean {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

export function omitNullFromObj(obj: any) {
  Object.keys(obj).filter(k => !obj[k]);
  return obj;
}
